<template>
  <div id="stepOne">
    <h3 v-if="isLoading">Getting your application...</h3>
    <b-form v-if="isLoaded">
      <span class="sub-head"> {{ savingText }}</span><br>
      <b-overlay no-center :show="disabled" rounded="lg" :opacity="'0.9'" :blur="'5px'">
      <b-form-group class="applicationWizard">
        <b-tabs v-model="activeTab" vertical pills card @activate-tab="indexChanged">
          <b-tab title="Welcome">
              <h3 class="sub-head-medium">Message from the SV Chair</h3>
              <h3>Welcome to the ACM SIGGRAPH 2026 Student Volunteer application!</h3>
              <h4>We are thrilled that you are interested in becoming a part of this dynamic and inspiring community.
              </h4>
              <p>SIGGRAPH is the premier conference for computer graphics and interactive techniques, and our Student
                Volunteers
                (SVs) are at the heart of what makes this event such a unique and transformative experience. As a
                Student
                Volunteer, you will have the opportunity to engage with the latest advancements in computer graphics,
                animation,
                visual effects, gaming, and emerging technologies. Beyond gaining insight into cutting-edge research and
                innovation, you will also connect with a vibrant network of professionals, educators, creators, and
                fellow
                students from around the world. </p>
              <p>This year, SIGGRAPH will take place in the beautiful city of Los Angeles, renowned for its thriving tech
                and
                creative industries. The conference promises an unforgettable mix of groundbreaking sessions, hands-on
                demonstrations, and immersive experiences—and as an SV, you will be integral to its success (while
                having fun
                too!).</p>
              <p>By joining the Student Volunteer Program, you’ll not only contribute to the seamless execution of the
                conference but also gain invaluable opportunities to:
              <ul style="list-style-type:square; padding-left: 15px">
                <li>Learn from industry leaders and visionaries through a variety of events like Production Sessions,
                  Labs and
                  Birds of a Feather presentations </li>
                <li>Network with peers and professionals who share your passion for computer graphics, animation, and
                  interactive techniques at events throughout the conference week</li>
                <li>Explore potential career paths and build skills that will serve you in the future at the Job Fair
                </li>
                <li>Learn how to start and maintain your own student chapter with special sessions through the
                  Professional and
                  Student Chapters Committee</li>
                <li>Access exclusive student-only materials and content</li>
                <li>And last but not least, experience a supportive and inclusive community that celebrates diversity,
                  innovation and the efforts of teamwork.</li>
              </ul>
              </p>
              <p>As you complete your application, please be aware that attention to detail is crucial. Ensure that all
                required
                fields are completed accurately and thoroughly, and double-check that your supporting documents are
                properly
                uploaded. Incomplete or incorrect submissions may impact the evaluation of your application and
                subsequent
                acceptance into the program. Out of fairness and consideration to all of the applicants waiting to have
                their
                work considered, late submissions will not be accepted under any circumstances. With this in mind, if
                you run
                into issues or have questions about the process, please reach out to us promptly at <a
                  href="mailto:sv-s2026@siggraph.org">sv-s2026@siggraph.org</a>. You
                can also find more information about the program through our <a
                  href="https://s2026.siggraph.org/program/student-volunteers/" target="_blank">FAQ</a>. We know that
                your
                enthusiasm, dedication, and unique perspective will enrich SIGGRAPH 2026 and make it an unforgettable
                experience
                for all. </p>
              <p>Thank you for your interest in the SIGGRAPH 2026 Student Volunteer Program. We look forward to
                reviewing your
                application and hopefully welcoming you to our amazing team! </p>
              <p>Best Regards,
                <br>Robert Kistner
                <br>Chair, Student Volunteer Subcommittee (SVSC)
              </p>
            
            <!-- <b-card-footer>
      <div class="row">
          <div class="col">
            <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-med float-left"
              @click="previousStep">
              <div>Return to Dashboard</div>
            </button>
          </div>
          <div class="col">
            <button type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-med float-right"
              @click="nextStep">
              <div>Start Application</div>
            </button>
          </div>
        </div>
    </b-card-footer> -->

          </b-tab>
          <b-tab title="Academic Information">
              <h2>Academic Information</h2>
              <p class="sub-head" style="text-transform: unset">Note: In order to be eligible, applicants must have been
                enrolled as full-time high
                school, undergraduate, or graduate students for at least one semester between June 2025 and September
                2026. Additionally, applicants must be 18 years old or older by 14 May 2026</p>
              <b-form-group>
                <b-form-group label="University / School / Institution Name" label-for="schoolName">
                  <b-form-input type="text" v-model="schoolName" id="schoolName"></b-form-input>
                </b-form-group>
                <b-form-group label="City" label-for="schoolCity">
                  <b-form-input type="text" v-model="schoolCity" id="schoolCity"></b-form-input>
                </b-form-group>
                <b-form-group label="State" label-for="schoolState">
                  <b-form-input type="text" v-model="schoolState" id="schoolState"></b-form-input>
                </b-form-group>
                <b-form-group label="Country" label-for="schoolCountry">
                  <b-form-select id="schoolCountry" v-model="schoolCountry" :options="countries">
                  </b-form-select>
                </b-form-group>
                <b-form-group>
                  <div class="row">
                    <div class="col">
                      <b-form-group label="Expected Graduation Month" label-for="expectedGraduationMonth">
                        <b-form-select id="expectedGraduationMonth" label="Month" v-model="expectedGraduationMonth"
                          :value="getExpectedGraduationMonth" :options="months"
                          @input="updateExpectedGraduationMonth"></b-form-select>
                      </b-form-group>
                    </div>
                    <div class="col">
                      <b-form-group label="Expected Graduation Year" label-for="expectedGraduationYear">
                        <b-form-select id="expectedGraduationYear" label="Year" v-model="expectedGraduationYear"
                          :options="years">
                        </b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                </b-form-group>
                <b-form-group v-if="proofOfEnrollmentExists" label="Proof of Enrollment">
                  <div class="row">
                    <div class="dz-image col col-md-3">
                      <img :alt="proofOfEnrollment.name" :src="getDataURL" />
                    </div>
                    <div class="dz-info col col-md-3 info">
                      <div style="position: relative;">
                        <div class="filename">Filename: {{ proofOfEnrollment.name }}</div>
                        <div class="size">File Size: {{ proofOfEnrollmentFileSize }} MB</div>
                        <button type="button" class="btn arrow-btn-primary btn-sm" @click="removeProofOfEnrollment">
                          <div>Remove File</div>
                        </button>
                      </div>
                    </div>
                  </div>
                </b-form-group>
                <b-form-group v-else label="Proof of Enrollment"
                  description="Drag and Drop file to upload. (File Types: PDF, JPEG) (Max Size: 4MB)">
                  <div class="dz">
                    <vue-dropzone ref="proofOfEnrollment" id="proofOfEnrollment" :options="dropzoneOptions"
                      @vdropzone-file-added="addedFile" @vdropzone-removed-file="removedFile"
                      @vdropzone-sending="sendingEvent" @vdropzone-success="uploadSuccessful" />
                  </div>
                </b-form-group>
              </b-form-group>
            <!-- <b-card-footer>
                <div class="row">
                  <div class="col">
                    <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-med float-left"
                      @click="previousStep">
                      <div>Previous Step</div>
                    </button>
                  </div>
                  <div class="col">
                    <button type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-med float-right"
                      @click="nextStep">
                      <div>Next Step</div>
                    </button>
                  </div>
                </div>
              </b-card-footer> -->
          </b-tab>
          <b-tab title="Professional References">
            <b-form-group style="flex-basis: 100%">
              <h2>Professional References</h2>
              <p>References will be contacted after applications close.</p>
              <b-tabs pills card class="reference-tab">
                <b-tab title="First Professional Reference">
                  <b-form-group>
                    <b-form-group label="Reference Type" label-for="firstReferenceType">
                      <b-form-select id="firstReferenceType" v-model="firstReferenceType" :options="referenceTypes">
                      </b-form-select>
                    </b-form-group>
                    <b-form-group label="Reference First Name" label-for="firstReferenceFirstName">
                      <b-form-input type="text" v-model="firstReferenceFirstName"
                        id="firstReferenceFirstName"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Reference Last Name" label-for="firstReferenceLastName">
                      <b-form-input type="text" v-model="firstReferenceLastName"
                        id="firstReferenceLastName"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Reference Email" label-for="firstReferenceEmail">
                      <b-form-input type="text" v-model="firstReferenceEmail" id="firstReferenceEmail"></b-form-input>
                    </b-form-group>
                  </b-form-group>
                </b-tab>
                <b-tab title="Second Professional Reference">
                  <b-form-group>
                    <b-form-group label="Reference Type" label-for="secondReferenceType">
                      <b-form-select id="secondReferenceType" v-model="secondReferenceType" :options="referenceTypes">
                      </b-form-select>
                    </b-form-group>
                    <b-form-group label="Reference First Name" label-for="secondReferenceFirstName">
                      <b-form-input type="text" v-model="secondReferenceFirstName"
                        id="secondReferenceFirstName"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Reference Last Name" label-for="secondReferenceLastName">
                      <b-form-input type="text" v-model="secondReferenceLastName"
                        id="secondReferenceLastName"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Reference Email" label-for="secondReferenceEmail">
                      <b-form-input type="text" v-model="secondReferenceEmail" id="secondReferenceEmail"></b-form-input>
                    </b-form-group>
                  </b-form-group>
                </b-tab>
              </b-tabs>
            </b-form-group>
          </b-tab>
          <b-tab title="SIGGRAPH Experience">
            <div style="display:flex;flex-direction:column;height:100%;flex-basis: 100%">
                <b-form-group>
                  <h2>SIGGRAPH Experience</h2>
                  <b-form-group>
                    <b-form-checkbox v-model="haveAttended" :disabled="haveNotAttended">I have participated in a
                      SIGGRAPH
                      North America Conference as an
                      attendee</b-form-checkbox>
                    <b-form-checkbox v-model="haveAttendedAsia" :disabled="haveNotAttended">I have participated in a
                      SIGGRAPH Asia Conference as an
                      attendee</b-form-checkbox>
                    <b-form-checkbox v-model="haveVolunteered" :disabled="haveNotAttended">I have participated in a
                      SIGGRAPH North America Conference as
                      a Student Volunteer</b-form-checkbox>
                    <b-form-checkbox v-model="haveVolunteeredAsia" :disabled="haveNotAttended">I have participated in a
                      SIGGRAPH Asia Conference as a
                      Student Volunteer</b-form-checkbox>
                    <b-form-checkbox v-model="haveNotAttended"
                      :disabled="haveAttended||haveAttendedAsia||haveVolunteered||haveVolunteeredAsia">This is my first
                      SIGGRAPH Conference</b-form-checkbox>
                  </b-form-group>
                  <b-form-group v-if="haveVolunteered"
                    label="Please select which years in which you have been a SIGGRAPH North America Student Volunteer."
                    label-for="yearsVolunteered">
                    <multiselect :options="previousSvYears" :value="getYearsVolunteered" :searchable="false"
                      :multiple="true" :close-on-select="false" :allow-empty="true" :hide-selected="true"
                      @input="updateYearsVolunteered">
                      <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option
                            }}</span><span class="custom__remove"
                            @click="props.remove(props.option)">❌</span></span></template>
                    </multiselect>
                  </b-form-group>
                  <b-form-group v-if="haveVolunteeredAsia"
                    label="Please select which years in which you have been a SIGGRAPH Asia Student Volunteer."
                    label-for="yearsVolunteered">
                    <multiselect :options="previousSvYears" :value="getYearsVolunteeredAsia" :searchable="false"
                      :multiple="true" :close-on-select="false" :allow-empty="true" :hide-selected="true"
                      @input="updateYearsVolunteeredAsia">
                      <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option
                            }}</span><span class="custom__remove"
                            @click="props.remove(props.option)">❌</span></span></template>
                    </multiselect>
                  </b-form-group>
                </b-form-group>
              <!-- <b-card-footer>
                <div class="row">
                  <div class="col">
                    <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-med float-left"
                      @click="previousStep">
                      <div>Previous Step</div>
                    </button>
                  </div>
                  <div class="col">
                    <button type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-med float-right"
                      @click="nextStep">
                      <div>Next Step</div>
                    </button>
                  </div>
                </div>
              </b-card-footer> -->
            </div>
          </b-tab>
          <b-tab title="Student Volunteer Essays" lazy>
            <b-form-group>
              <h2>Student Volunteer Questions</h2>
              <h3>Question 1</h3>
              <b-form-group label="The SIGGRAPH Student Volunteer program is built on a philosophy of gratitude—treating every challenge as an opportunity to serve others while celebrating our shared passion for computer graphics and interactive techniques. What draws you to volunteer at SIGGRAPH 2026 specifically, and how would your unique strengths and experiences help you contribute meaningfully to the conference?" label-for="essay1">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="essay1" @input="wordCount('essay1', 300)" v-model="essay1" rows="10"
                      max-rows="100"></b-form-textarea>
                    <p :class="essay1WordLimitClass">{{ essay1WordCount }}</p>
                  </div>
                </div>
              </b-form-group>
              <h3>Question 2</h3>
              <b-form-group label="Student Volunteers work in fast-paced, diverse teams where assignments can change based on conference needs. Describe a time when you successfully collaborated with others in a dynamic environment where priorities shifted or you worked with people from different backgrounds or working styles." label-for="essay2">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="essay2" @input="wordCount('essay2', 300)" v-model="essay2" rows="10"
                      max-rows="100"></b-form-textarea>
                    <p :class="essay2WordLimitClass">{{ essay2WordCount }}</p>
                  </div>
                </div>
              </b-form-group>
              <h3>Question 3</h3>
              <b-form-group label="Conference environments require volunteers who can think on their feet and maintain a positive, professional demeanor under pressure. Share a specific example of when you encountered an unexpected challenge while working with or serving others—what actions did you take, and what did you learn about handling pressure?" label-for="essay3">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="essay3" @input="wordCount('essay3', 300)" v-model="essay3" rows="10"
                      max-rows="100"></b-form-textarea>
                    <p :class="essay3WordLimitClass">{{ essay3WordCount }}</p>
                  </div>
                </div>
              </b-form-group>
            </b-form-group>
          </b-tab>
          <b-tab title="Team Leader Essays" lazy>
            <b-form-group>
              <h2>Become a Team Leader</h2>
              <p v-if="pastTLAppDeadline">The deadline for Team Leader applications has passed</p>
              <div v-else>
                <p>Only SIGGRAPH Student Volunteers with at least 1 year of prior SV experience are eligible for Team
                  Leader positions. Team Leaders (TLs) are Student Volunteers (SVs) selected to serve as liaisons to
                  Venue and Program Chairs across the different areas of the conference.</p>
                <p>TLs have more responsibility and a more demanding workload than a regular SV. TLs serve in a
                  supervisory role as they help train SVs to perform different duties, and resolve more complex
                  attendee, contributor and volunteer questions and issues. TLs also volunteer approximately 60 hours
                  either in pre-conference shifts or during the SIGGRAPH week in addition to several pre-conference
                  training sessions.</p>
                <p>Please keep in mind the TL application process is very competitive. TL applicants not selected for
                  the role will still be considered for a position as SV.</p>
              </div>
              <b-form-group>
                <b-form-checkbox id="teamLeader" v-model="teamLeader" :disabled="pastTLAppDeadline || haveNotAttended">
                  I would like to apply for a Team Leader position
                </b-form-checkbox>
              </b-form-group>
              <h3 v-if="teamLeader">Question 1</h3>
              <b-form-group v-if="teamLeader"
                label="Team Leaders serve as supervisors and liaisons who support Student Volunteers while managing operational needs across the conference. Reflecting on your experience as a SIGGRAPH or SIGGRAPH Asia Student Volunteer, what specific moments or observations inspired you to take on a leadership role? What aspects of the Team Leader position—whether mentoring SVs, resolving challenges, or bridging communication between volunteers and conference programs—excite you most, and why do you feel ready for this greater level of responsibility?"
                label-for="teamLeaderEssay1">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="teamLeaderEssay1" @input="wordCount('teamLeaderEssay1', 300)"
                      v-model="teamLeaderEssay1" :rows="10" :max-rows="100" />
                    <p :class="teamLeaderEssay1WordLimitClass">{{ teamLeaderEssay1WordCount }}</p>
                  </div>
                </div>
              </b-form-group>
              <h3 v-if="teamLeader">Question 2</h3>
              <b-form-group v-if="teamLeader"
                label="Team Leaders must balance multiple responsibilities: checking in SVs, resolving conflicts, monitoring team morale, making decisions under pressure, and ensuring every volunteer feels supported throughout long, demanding shifts. Describe a specific leadership or supervisory experience where you had to support someone who was struggling, overwhelmed, or facing a challenge while simultaneously managing your other responsibilities. How did you prioritize, what approach did you take to support them, and what did this experience teach you about creating a positive environment for a diverse team?"
                label-for="teamLeaderEssay2">
                <div class="row">
                  <div class="col">
                    <b-form-textarea id="teamLeaderEssay2" @input="wordCount('teamLeaderEssay2', 300)"
                      v-model="teamLeaderEssay2" :rows="10" :max-rows="100" />
                    <p :class="teamLeaderEssay2WordLimitClass">{{ teamLeaderEssay2WordCount }}</p>
                  </div>
                </div>
              </b-form-group>
            </b-form-group>
          </b-tab>
          <b-tab title="Financial Aid" lazy>
            <b-form-group>
              <h2>Financial Assistance</h2>
              <p>Travel assistance may be provided based on the Student Volunteer Program's availability of funds and on
                eligibility, which is determined on a case-by-case basis based solely on financial need. Assistance goes
                through a blind jury process. It is not based on nationality or country/location of residence, anyone
                can apply and everyone will be considered equally. Funds are limited and assistance is not guaranteed.
                Travel assistance, if awarded, will be communicated upon acceptance.</p>
              <p>If you would like to be considered for financial assistance, you <i>must</i> complete the section below.</p>
              <b-form-group>
                <b-form-checkbox id="financialAid" v-model="financialAid">
                  I would like to apply for financial assistance
                </b-form-checkbox>
              </b-form-group>
              <b-form-group v-if="financialAid">
                <b-form-group label="We understand that attending SIGGRAPH can be a considerable financial investment. Please share
                      with us why financial assistance would be important for you to participate"
                  label-for="financialAidSummary">
                  <b-form-textarea id="financialAidSummary" @input="wordCount('financialAidSummary', 100)"
                    v-model="financialAidSummary" :rows="6" :max-rows="100" />
                  <p :class="financialAidSummaryWordLimitClass">{{ financialAidSummaryWordCount }}</p>
                </b-form-group>
                <b-form-group label="Please select any situations that apply to your request for financial assistance:"">
                <multiselect :options=" financialSituationOptions" :value="getFinancialSituation" :searchable="false"
                  :multiple="true" :close-on-select="false" track-by="value" label="text" :allow-empty="true"
                  :hide-selected="true" @input="updateFinancialSituation">
                  <template slot="tag" slot-scope="props"><span class="custom__tag"><span>{{ props.option.text
                        }}</span><span class="custom__remove"
                        @click="props.remove(props.option)">❌</span></span></template>
                  </multiselect>
                </b-form-group>
                <b-form-group label="Please provide an itemized breakdown of your anticipated travel expenses in US dollars
                      (Typically assistance would include provisions for things like travel, lodging, food, conference
                      transport, etc)." label-for="financialAidExpenses">
                  <b-form-textarea id="financialAidExpenses" v-model="financialAidExpenses" :rows="6" :max-rows="100" />
                </b-form-group>
                <b-form-group label="Sum up your previous calculations into a total estimate in US dollars."
                  label-for="estimatedTravelCost">
                  <b-form-input type="text" v-model="estimatedTravelCost" id="estimatedTravelCost"></b-form-input>
                </b-form-group>
                <b-form-group label="Primary Mode of Transportation to the Conference's City"
                  label-for="primaryTransport">
                  <b-form-select id="primaryTransport" v-model="primaryTransport" :options="primaryTransportList" />
                </b-form-group>
                <b-form-group v-if="financialAidAndFlying"
                  label="If you will be flying, what is the 3-letter code for the airport you will be departing from? (Ex: IND for Indianapolis International Airport)"
                  label-for="airportCode">
                  <b-form-input type="text" v-model="airportCode" id="airportCode"
                    style="max-width:100px"></b-form-input>
                </b-form-group>
                <b-form-group v-if="financialAidAndOtherTransport"
                  label="Please explain how you are planning to travel to the conference" label-for="otherTransport">
                  <b-form-input type="text" v-model="otherTransport" id="otherTransport"></b-form-input>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox id="fundedTravel" v-model="fundedTravel">
                    Funding for my travel will be fully or partially covered by outside sources (such as university
                    funding, etc.).
                  </b-form-checkbox>
                </b-form-group>
              </b-form-group>
            </b-form-group>
          </b-tab>
          <b-tab no-body title="Confirmation of Responsibilities">
            <b-card-body>
            <b-form-group>
              <h2>Confirmation of Responsibilities</h2>
              <div id="expectations" class="row">
                <div class="col">
                  <h4>Expectations</h4>
                  <p>Student Volunteers and Team Leaders are required to complete training provided by the Student
                    Volunteer Program after accepting a position.</p>
                  <p>Student Volunteers and Team Leaders will serve the conference via pre-conference shifts and/or shifts during the conference (at SIGGRAPH 2026 in Los Angeles).</p>
                  <p>Student Volunteers commit to volunteering about 25 hours to provide operational support for
                    SIGGRAPH 2026 in pre-conference shifts and/or shifts during the conference. In exchange for their service
                    and enthusiasm, Student Volunteers receive a full conference registration pass for the conference,
                    networking opportunities, and a number of exclusive Student Volunteer-only benefits.</p>
                  <p>Team Leaders are expected to volunteer about 60 hours to provide operational and logistical support
                    for SIGGRAPH 2026 pre-conference shifts or shifts during the conference. In exchange for their service
                    and enthusiasm, Team Leaders receive a full conference registration pass for the conference,
                    networking opportunities, and a number of exclusive Student Volunteer-only benefits.</p>
                  <p>Important Points to Note:
                  <ul style="list-style-type:square; padding-left: 15px">
                    <li>You are expected to participate in SIGGRAPH 2026 all day from 18-23 July 2026 in Los Angeles, California.</li>
                    <li>DO NOT plan to depart the Los Angeles Convention Center earlier than 6 pm (PDT) on 23 July 2026.</li>
                    <li>No housing or accommodation will be provided to Team Leaders or Student Volunteers.
                      Opportunities to coordinate lodging with other student volunteers will be made available after
                      acceptance into the program.</li>
                    <li>More details on what is involved in being a Student Volunteer will be provided during the
                      upcoming months.</li>
                  </ul>
                  </p>
                </div>
              </div>
              <div id="ethics" class="row">
                <div class="col">
                  <h4>Ethics</h4>
                  <p>We hold ourselves and our Student Volunteers to the highest standards of professionalism,
                    integrity, and respect. It is essential that all individuals involved in the conference—including
                    attendees, volunteers, contributors, and contractors—are treated with courtesy and dignity. We are
                    committed to fostering an environment that is inclusive, welcoming, and conducive to productive
                    collaboration. Any breach of these expectations, whether through unprofessional conduct,
                    disrespectful behavior, threats, harassment, or failure to comply with the guidelines, will not be
                    tolerated. Such actions undermine the spirit of cooperation that defines our community and could
                    lead to removal from the program. Additionally, any violation may also result in the revocation of
                    access to the conference and its associated events.</p>
                  <p>Understanding also that through your interactions with contributors you may be privy to sensitive
                    or confidential information, by affirming your understanding of these guidelines you also verify
                    your
                    agreement to keep such information private.</p>
                </div>
              </div>
              <div id="benefits" class="row">
                <div class="col">
                  <h4>Benefits</h4>
                  <h5>Full Conference Registration</h5>
                  <p>Enjoy all of the latest and greatest this amazing conference has to offer! SIGGRAPH offers many
                    opportunities to explore the latest innovations when you are off-shift.</p>
                  <h5>Student Volunteer Special Sessions</h5>
                  <p>Hear top professionals in the industry and academia (some of them former Student Volunteers) speak
                    about tips, tricks, and job opportunities at exclusive “Student Volunteers-only” sessions before
                    SIGGRAPH 2026!</p>
                  <h5>Résumé and Reel Review Sessions</h5>
                  <p>Polish your reel and résumé, and get some professional feedback (virtually and in-person) to land
                    your dream job! Space is limited. This program is made possible by the SIGGRAPH Student Services
                    Committee (S3), and depends on the provided time of industry experts who are volunteers just like
                    you!</p>
                  <h5>Professional Development</h5>
                  <p>Expand your knowledge outside the classroom through leadership, mentoring, and diversity &
                    inclusion sessions tailored specially for student volunteers.</p>
                  <h5>Networking</h5>
                  <p>Participate in the many events and get-togethers we will organize prior to and during the
                    conference. Meet students from all over the globe who share your passion for computer graphics and
                    interactive techniques!</p>
                </div>
              </div>
              <div id="deadlines" class="row">
                <div class="col">
                  <h4>Deadlines (submissions will close at 22:00 UTC/GMT)</h4>
                  <h6 class="sub-head">{{ formattedDate(applicationTlEndDate) }}: Team Leader Applications</h6>
                  <p>Team Leader application results will be sent in mid-February 2026. You will receive an email
                    notification at the address you provided in your application. Applicants who are not accepted as
                    Team Leaders will still be considered for Student Volunteer positions.</p>
                  <h6 class="sub-head">{{ formattedDate(applicationEndDate) }} : Student Volunteer Applications</h6>
                  <p>Student Volunteer application results will be sent by mid-April 2026. You will receive an email
                    notification at the address you provided in your application, and be required to confirm your
                    position by late April 2026, or potentially forfeit your spot in the program. If you applied for
                    financial aid, you will be notified of any funds awarded with the results of your application. These
                    funds will not be released to you until after the conference.</p>
                </div>
              </div>
              <h4>Terms and Responsibilities Agreement</h4>
              <p>Please take a moment to carefully review the <a
                  href="https://s2026.siggraph.org/program/student-volunteers/" target="_blank">Student Volunteer
                  Eligibility Requirements and
                  Responsibilities</a>. Once you have read them, confirm that you meet the criteria, are eligible to
                participate, and are willing to comply with the responsibilities described.</p>
              <b-form-group>
                <b-form-checkbox id="acceptedTerms" v-model="acceptedTerms">
                  I have read these requirements and affirm my eligibility and willingness to participate in the Student
                  Volunteer Program
                </b-form-checkbox>
              </b-form-group>
              <h4>Media Release Agreement</h4>
              <p>I grant permission for ACM/SIGGRAPH and its agents or employees to take and use photographs and/or
                video taken of me for use in promotional and educational electronic, video, and print materials for the
                SIGGRAPH organization. Furthermore, I authorize the use of my name, likeness, and voice for all SIGGRAPH
                Conference and organization promotion deemed appropriate and necessary by ACM/SIGGRAPH.</p>
              <p>I hereby waive any right of privacy and the right to inspect or approve the finished photographs or
                video that may be used in conjunction with such use now or in the future, whether that use is known to
                me or unknown. I also waive any right to royalties or other compensation arising from or related to the
                use of said photographs/video created for this purpose.</p>
              <p>I have read this release before accepting the conditions below, and I fully understand the contents,
                meaning, and impact of this release. I understand that I am free to address any specific questions
                regarding this release by submitting those questions in writing prior to signing, and I agree that my
                failure to do so will be interpreted as a free and knowledgeable acceptance of the terms of this
                release.</p>
              <b-form-group class="mt-4">
                <b-form-checkbox id="acceptedMediaRelease" v-model="acceptedMediaRelease">I Agree</b-form-checkbox>
              </b-form-group>
              <h4>Privacy Policy Agreement</h4>
              <p>I have read and accept the <a href="https://www.acm.org/about-acm/privacy-policy">ACM Privacy
                  Policy</a></p>
              <b-form-group class="mt-4">
                <b-form-checkbox id="acceptedPrivacy" v-model="acceptedPrivacy">
                  I Agree
                </b-form-checkbox>
              </b-form-group>
              <h4>Additional Comments</h4>
              <b-form-group
                label="We look forward to reviewing your application! Is there anything else you would like to share?"
                label-for="otherComments">
                <b-form-textarea id="otherComments" @input="wordCount('otherComments', 100)" v-model="otherComments"
                  :rows="6" :max-rows="100" />
                <p :class="otherCommentsWordLimitClass">{{ otherCommentsWordCount }}</p>
              </b-form-group>
              <!-- <div class="row" style="float: right;margin: unset;align-items: baseline;">
                <p style="margin-right:15px">{{ savingText }}</p>
                <button type="submit" :disabled="disabled" class="btn" @click="saveApplication">
                  Save Progress
                </button>
              </div> -->
            </b-form-group>
          </b-card-body>
          <!-- <b-card-footer>
        <div class="row">
          <div class="col">
            <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-med float-left"
              @click="previousStep">
              <div>Previous Step</div>
            </button>
          </div>
          <div class="col">
            <button type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-med float-right"
              @click="submitApplication">
              <div>Submit Application</div>
            </button>
          </div>
        </div>
      </b-card-footer> -->
          </b-tab>
        </b-tabs>
        <b-card-footer>
        <div class="row">
          <div v-if="activeTab !== 0" class="col">
            <button type="submit" :disabled="disabled" class="btn left-arrow-btn-primary btn-med float-left"
              @click="previousStep">
              <div>Previous Step</div>
            </button>
          </div>
          <!-- <div class="col" style="flex-basis: min-content;text-align: center;">
            <span class="sub-head"> {{ savingText }}</span>
          </div> -->
          <div class="col">
            <button v-if="activeTab !== 7" type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-med float-right"
              @click="nextStep">
              <div>Next Step</div>
            </button>
            <button v-else type="submit" :disabled="disabled" class="btn arrow-btn-primary btn-med float-right"
              @click="submitApplication">
              <div>Submit Application</div>
            </button>
          </div>
        </div>
      </b-card-footer>
      </b-form-group>
      <template #overlay>
        <div style="display: flex;flex-direction: column;align-items: center;margin-top: 2em;">
          <h3 class="text-white">Saving Progress...</h3>
          <b-spinner></b-spinner>
        </div>
      </template>
    </b-overlay>
    </b-form>
  </div>
</template>

<script>
import { countries, months, years, previousSvYears, referenceTypes, primaryTransportList, financialSituationOptions } from '@/util/SelectLists'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Multiselect from 'vue-multiselect'
import { mapState, mapGetters } from 'vuex'
import router from '@/router'
import moment from 'moment'

const generateVuexSetters = (fields) => {
  let computed = {}
  fields.forEach(field => {
    computed[field] = {
      get () {
        return this.$store.state.application.data[field]
      },
      set (value) {
        this.$store.commit('application/updateField', { name: field, value })
      }
    }
  })
  return computed
}

export default {
  name: 'AppStepOne',
  data () {
    return {
      countries: countries,
      months: months,
      years: years,
      previousSvYears: previousSvYears,
      referenceTypes: referenceTypes,
      dropzoneOptions: {
        acceptedFileTypes: ['image/jpg', 'image/jpeg', 'application/pdf'],
        url: 'changeme',
        maxFiles: 1,
        method: 'PUT',
        autoProcessQueue: false,
        renameFile: file => {
          let filename = this.$store.state.user.profile.svid + '.' + file.type.substring(file.type.indexOf('/') + 1)
          return filename
        }
      },
      essay1WordCount: '300 words remaining',
      essay1WordLimitClass: 'under-limit',
      essay2WordCount: '300 words remaining',
      essay2WordLimitClass: 'under-limit',
      essay3WordCount: '300 words remaining',
      essay3WordLimitClass: 'under-limit',
      teamLeaderEssay1WordCount: '300 words remaining',
      teamLeaderEssay1WordLimitClass: 'under-limit',
      teamLeaderEssay2WordCount: '300 words remaining',
      teamLeaderEssay2WordLimitClass: 'under-limit',
      otherCommentsWordCount: '300 words remaining',
      otherCommentsWordLimitClass: 'under-limit',
      primaryTransportList: primaryTransportList,
      financialSituationOptions: financialSituationOptions,
      financialAidSummaryWordCount: '100 words remaining',
      financialAidSummaryWordLimitClass: 'under-limit',
      disabled: false,
      savingText: '',
      activeTab: -1
    }
  },
  computed: {
    ...generateVuexSetters([
      'schoolName',
      'schoolCity',
      'schoolState',
      'schoolCountry',
      'expectedGraduationMonth',
      'expectedGraduationYear',
      'haveNotAttended',
      'haveAttended',
      'haveVolunteered',
      'yearsVolunteered',
      'haveAttendedAsia',
      'haveVolunteeredAsia',
      'yearsVolunteeredAsia',
      'firstReferenceType',
      'firstReferenceFirstName',
      'firstReferenceLastName',
      'firstReferenceEmail',
      'secondReferenceType',
      'secondReferenceFirstName',
      'secondReferenceLastName',
      'secondReferenceEmail',
      'essay1',
      'essay2',
      'essay3',
      'teamLeaderEssay1',
      'teamLeaderEssay2',
      'otherComments',
      'financialAidSummary',
      'primaryTransport',
      'airportCode',
      'otherTransport',
      'financialAidExpenses',
      'financialSituation',
      'estimatedTravelCost',
      'fundedTravel',
      'acceptedTerms',
      'acceptedMediaRelease',
      'acceptedPrivacy'
    ]),
    proofOfEnrollment: {
      get () {
        return this.$store.state.application.data.proofOfEnrollment
      }
    },
    teamLeader: {
      get () {
        return this.$store.state.application.teamLeader
      },
      set (value) {
        this.$store.commit('application/updateTeamLeader', value)
      }
    },
    financialAid: {
      get () {
        return this.$store.state.application.financialAid
      },
      set (value) {
        this.$store.commit('application/updateFinancialAid', value)
      }
    },
    ...mapGetters('application', [
      'proofOfEnrollmentExists',
      'proofOfEnrollmentFileSize',
      'getDataURL',
      'getExpectedGraduationMonth',
      'getExpectedGraduationYear',
      'getYearsVolunteered',
      'getYearsVolunteeredAsia',
      'financialAidAndFlying',
      'financialAidAndOtherTransport',
      'getFinancialSituation'
    ]),
    ...mapGetters(['pastTLAppDeadline']),
    ...mapState('application', ['isLoaded', 'isLoading']),
    ...mapState(['applicationTlEndDate', 'applicationEndDate'])
  },
  methods: {
    formattedDate: function (date) {
      return moment(date).tz('UTC').format('D MMMM YYYY')
    },
    addedFile (file) {
      if (file.size < 4000000) {
        this.$store.dispatch('application/getSignedUrl', { fileType: file.type }).then(url => {
          console.log(url)
          this.$refs.proofOfEnrollment.setOption('url', url)
          this.$refs.proofOfEnrollment.processQueue()
        })
      } else {
        // File is too big
        this.$refs.proofOfEnrollment.removeFile(file)
      }
    },
    removedFile (file) {
      if (file.size > 4000000) {
        this.$store.commit('error', { message: 'File size is too large. Please keep uploads under 4 MB' })
      }
    },
    sendingEvent (file, xhr) {
      var _send = xhr.send
      xhr.send = function () {
        _send.call(xhr, file)
      }
    },
    uploadSuccessful (file, response) {
      if (file.type === 'application/pdf') {
        file.dataURL = ''
      }
      this.$store.commit('application/fileUploaded', {
        name: file.upload.filename,
        type: file.type,
        dataURL: file.dataURL,
        size: file.size
      })
      this.$store.dispatch('application/save')
    },
    removeProofOfEnrollment (e) {
      this.$store.commit('application/removeProofOfEnrollment')
    },
    updateExpectedGraduationMonth (value) {
      console.log(value)
      this.$store.commit('application/updateField', { name: 'expectedGraduationMonth', value: value })
    },
    updateExpectedGraduationYear (value) {
      this.$store.commit('application/updateField', { name: 'expectedGraduationYear', value: value })
    },
    updateYearsVolunteered (value) {
      this.$store.commit('application/updateField', { name: 'yearsVolunteered', value: value })
    },
    updateYearsVolunteeredAsia (value) {
      this.$store.commit('application/updateField', { name: 'yearsVolunteeredAsia', value: value })
    },
    updateFinancialSituation (value) {
      this.$store.commit('application/updateField', { name: 'financialSituation', value: value })
    },
    wordCount (field, limit) {
      let words = this[field].trim().split(/\s+/)
      let wordCount = (words.length === 1 && words[0] === '') ? 0 : words.length
      let remaining = limit - wordCount
      this[field + 'WordCount'] = (remaining < 0) ? (remaining * -1).toString() + ' words over the limit, you will not be able to submit your application' : remaining.toString() + ' words remaining'
      this[field + 'WordLimitClass'] = (remaining < 0) ? 'over-limit' : 'under-limit'
    },
    nextStep (e) {
      e.preventDefault()
      // this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.activeTab++
        // this.$store.commit('application/updateStep', this.activeTab + 1)
        // this.$store.dispatch('application/save').then(() => {
        //   // router.push({ name: 'stepFive' })
        //   this.activeTab++
        //   this.disabled = false
        //   this.savingText = 'Last Save at ' + moment().format('LLL')
        //   window.scrollTo(0, 0)
        // }).catch(err => {
        //   console.log(err.message)
        //   this.disabled = false
        // })
      }
    },
    indexChanged (newIndex, prevIndex, e) {
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        if (newIndex !== this.$store.state.application.step) {
          window.scrollTo(0, 100)
          if (newIndex > prevIndex) {
            this.disabled = true
            this.savingText = ''
            this.$store.commit('application/updateStep', newIndex)
            this.$store.dispatch('application/save').then(() => {
              this.disabled = false
              this.savingText = 'Last Save: ' + moment().format('LLL')
            }).catch(err => {
              console.log(err.message)
              this.disabled = false
            })
          } else {
            this.$store.commit('application/updateStep', newIndex)
          }
        }
      }
    },
    // saveApplication (e) {
    //   e.preventDefault()
    //   this.disabled = true
    //   this.savingText = 'Saving...'
    //   if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
    //     router.push('/dashboard')
    //   } else {
    //     this.$store.dispatch('application/save').then(() => {
    //       this.disabled = false
    //       this.savingText = 'Last Save: ' + moment().format('LLL')
    //     }).catch(err => {
    //       console.log(err.message)
    //       this.disabled = false
    //       this.savingText = 'Error Saving'
    //     })
    //   }
    // },
    previousStep (e) {
      e.preventDefault()
      // this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        // this.$store.commit('application/updateStep', this.activeTab - 1)
        this.activeTab--
        // this.$store.dispatch('application/save').then(() => {
        //   // router.push({ name: 'welcome' })
        //   this.activeTab--
        //   this.disabled = false
        //   this.savingText = 'Last Save at ' + moment().format('LLL')
        // }).catch(err => {
        //   console.log(err.message)
        //   this.disabled = false
        // })
      }
    },
    submitApplication (e) {
      e.preventDefault()
      window.scrollTo(0, 100)
      this.disabled = true
      if (moment().tz('UTC').isAfter(this.$store.state.applicationEndDate)) {
        router.push('/dashboard')
      } else {
        this.$store.dispatch('application/save').then(() => {
          router.push({ name: 'stepFive' })
          this.disabled = false
        }).catch(err => {
          console.log(err.message)
          this.disabled = false
        })
      }
    }
  },
  created: function () {
    if (!this.$store.state.application.isLoaded) {
      this.$store.dispatch('application/load').then(() => {
        if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
          this.$store.commit('application/disableTeamLeader')
        }
        if (this.$store.state.application.completed) {
          router.push('/dashboard')
        } else if (this.$store.state.application.isNew) {
          this.savingText = ''
          this.$store.dispatch('application/save')
        }
        this.activeTab = this.$store.state.application.step
        this.savingText = 'Last Save: ' + moment(this.$store.state.application.updatedAt).local().format('LLL')
      })
    } else {
      if (this.$store.state.application.isNew) {
        this.savingText = ''
        this.$store.dispatch('application/save')
      } else {
        this.savingText = 'Last Save: ' + moment(this.$store.state.application.updatedAt).local().format('LLL')
      }
      this.activeTab = this.$store.state.application.step
    }
    if (this.$store.getters['pastTLAppDeadline'] && this.$store.state.application.teamLeader) {
      this.$store.commit('application/disableTeamLeader')
    }
    if (this.$store.state.application.completed) {
      router.push('/dashboard')
    }
  },
  mounted: function () {
    this.wordCount('essay1', 300)
    this.wordCount('essay2', 300)
    this.wordCount('essay3', 300)
    this.wordCount('teamLeaderEssay1', 300)
    this.wordCount('teamLeaderEssay2', 300)
    this.wordCount('otherComments', 100)
    this.wordCount('financialAidSummary', 100)
  },
  components: {
    vueDropzone: vue2Dropzone,
    multiselect: Multiselect
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/FileUploader.scss';
@import '../../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
</style>



// WEBPACK FOOTER //
// src/components/application/StepOne.vue